import { render, staticRenderFns } from "./TestLinkAccountAPISideBar.vue?vue&type=template&id=169b3c3e"
import script from "./TestLinkAccountAPISideBar.vue?vue&type=script&lang=js"
export * from "./TestLinkAccountAPISideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports